export enum ComponentThemeType {
  BLUE = 'blue',
  BLUE_LIGHT = 'blue-light',
  BLUE_ALT = 'blue-alt',
  YELLOW = 'yellow',
  RED = 'red',
  GRAY = 'gray', // TODO: add to cp-button https://massmutual.atlassian.net/browse/HL-34080
  DS_BLUE = 'ds-blue',
}

export enum ComponentSizeType {
  SMALL = 'small',
  REGULAR = 'regular',
  LARGE = 'large',
}

export enum ComponentVariantType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  BLUE = 'blue',
  BLUE_ALT = 'blue-alt',
}
